import type { CommonSVGProps } from './helpers';

export const TaskIcon = (props: CommonSVGProps) => {
  return (
    <svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2738_1202)">
        <path
          d="M3 12C2.175 12 1.5 11.325 1.5 10.5V3C1.5 2.175 2.175 1.5 3 1.5H10.5C11.325 1.5 12 2.175 12 3M7.5 6H15C15.8284 6 16.5 6.67157 16.5 7.5V15C16.5 15.8284 15.8284 16.5 15 16.5H7.5C6.67157 16.5 6 15.8284 6 15V7.5C6 6.67157 6.67157 6 7.5 6Z"
          stroke="#3D3D3D"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
      </g>
      <defs>
        <clipPath id="clip0_2738_1202">
          <rect fill="white" height="18" width="18" />
        </clipPath>
      </defs>
    </svg>
  );
};
